import { DELETE_VENDOR_FAILURE, DELETE_VENDOR_REQUEST, GET_VENDORS_FAILURE, GET_VENDORS_REQUEST, GET_VENDORS_SUCCESS, APPROVED_VENDOR_FAILURE, APPROVED_VENDOR_REQUEST, BLOCKED_VENDOR_REQUEST, BLOCKED_VENDOR_FAILURE, UNBLOCKED_VENDOR_REQUEST, UNBLOCKED_VENDOR_FAILURE, ADD_VENDOR_REQUEST, ADD_PENALTY_REQUEST, ADD_PENALTY_FAILURE, ADD_VENDOR_FAILURE, UPDATE_VENDOR_REQUEST, UPDATE_VENDOR_FAILURE, DELETE_VENDOR_SUCCESS } from "./ActionType";


const initialState = {
    loading: false,
    vendors: [],
    error: "",
}

const adminVendorReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_VENDORS_REQUEST:
            return { ...state, loading: true };

        case GET_VENDORS_SUCCESS:
            return { ...state, loading: false, vendors: action.payload, error: "" };

        case GET_VENDORS_FAILURE:
            return { ...state, loading: false, vendors: [], error: action.payload };

        case APPROVED_VENDOR_REQUEST:
        case BLOCKED_VENDOR_REQUEST:
        case UNBLOCKED_VENDOR_REQUEST:
        case ADD_VENDOR_REQUEST:
        case ADD_PENALTY_REQUEST:
        case UPDATE_VENDOR_REQUEST:
            return { ...state, loading: true, error: "" }

        case APPROVED_VENDOR_FAILURE:
        case BLOCKED_VENDOR_FAILURE:
        case UNBLOCKED_VENDOR_FAILURE:
        case ADD_VENDOR_FAILURE:
        case ADD_PENALTY_FAILURE:
        case UPDATE_VENDOR_FAILURE:
            return { ...state, loading: false, error: action.payload };

        case DELETE_VENDOR_REQUEST:
            return { ...state, loading: true, error: "" };

        case DELETE_VENDOR_SUCCESS:
            return {
                ...state,
                loading: false,
                error: "",
                vendors: state.vendors?.response?.filter(vndr => vndr.id !== action.payload)
            };

        case DELETE_VENDOR_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
}
export default adminVendorReducer